//Comentario necesario para codificación en UTF-8, ver Inc6743
'use strict';

(function () {
	var App = angular.module('pphhApp');
	App.service('ageSendaService', ['$http', function ($http) {
		this.getConnections = function() {
			var request = {
					method: "GET",
					url: _contextPath + "/age/syncInfo"
				};
			return $http(request);
		}
		
		this.getStatus = function() {
			var request = {
					method: "GET",
					url: _contextPath + "/age/sendaSyncStatus"
				};
			return $http(request);
		}		
	
	}]);
})();
